import { CSSProperties, FC, HTMLAttributes } from "react";
import cx from "classnames";

import "./fontello/css/fontello.css";

export enum IconTypes {
    ADD = "add",
    ADD_COLLABORATOR = "add-collaborator",
    OPEN = "open",
    CLOSE = "close",
    CLOSE_DELETE = "close-delete",
    CHOICES = "choices",
    DATE_TIME = "date-time",
    DESIGN = "design",
    DOWN = "down",
    DUPLICATE = "dublicate",
    EDIT = "edit",
    EYE_OFF = "eye-off",
    EYE = "eye",
    INPUT_FIELD = "input-field",
    INTEGRATION = "integration",
    LOGIC = "logic",
    MORE_ADVANCED = "more-advanced",
    PAGINATION = "pagination",
    PAGE_SCROLL = "page-scroll",
    PAYMENT = "payment",
    PREVIEW = "preview",
    PREVIOUS = "previous",
    SETTINGS = "settings",
    SIX_DOTS = "six-dots",
    SIGNATURE = "signature",
    TEXTS = "texts",
    VALIDATION = "validate",
    NEXT = "next",
    VERIFIED = "verified",
    INFO = "info",
    ASTERISK = "asterisk",
    TRASH = "trash",
    ARROW_LEFT = "arrow-left",
    ARROW_RIGHT = "arrow-right",
    MENU = "menu",
    DESKTOP = "desktop",
    TABLET = "tablet",
    MOBILE = "mobile",
    SINGLE_LINE = "single-line",
    MULTI_LINE = "multi-line",
    NAME = "name",
    ADDRESS = "address",
    MAIL = "mail",
    PHONE = "phone",
    NUMBER = "number",
    LINK = "link",
    PASSWORD = "password",
    PRICE_MENU = "price-menu",
    CHECKBOX = "checkbox",
    RADIO_BUTTON = "radio-button",
    STAR_RATE = "star-rate",
    SCALE = "scale",
    TERMS_AND_CONDITIONS = "terms-and-conditions",
    DATE_MOUNTH = "date-month",
    TIME = "time",
    TIMEZONE = "timezone",
    HEADING = "heading",
    DESCRIPTION = "description",
    MAP = "map-pin",
    CUSTOM_HTML = "custom-html",
    UPLOAD = "upload",
    FILL_IN_THE_BLANK = "fill-in-the-blank",
    MATRIX = "matrix",
    ATTENTION = "attention",
    LEFT_ALIGN = "left-align",
    CENTER_ALIGN = "center-align",
    RIGHT_ALIGN = "right-align",
    ALIGN_LEFT = "align-left",
    ALIGN_CENTER = "align-center",
    ALIGN_RIGHT = "align-right",
    ITALIC = "italic",
    LIMITS = "limits",
    NOTIFICATION = "notification",
    SAVE_PROGRESS = "save-progress",
    CONFIRMATION = "conformation",
    CIRCLE_UNDEFILLED = "circle-unfilled",
    SWITCH = "circle-pn",
    BOLD = "bold",
    UNDERLINE = "underline",
    RADIUS = "radius",
    BORDERS = "borders",
    STRIKE = "strikethrough",
    FONT_COLOR = "font-color",
    UP = "up",
    LOGIC_ON = "logic-on",
    LOGIC_OFF = "logic-off",
    HELP = "help",
    LOG_OUT = "log-out",
    CONFIRMED = "confirmed",
    LETTER = "letter",
    PRICE = "price",
    QUANTITY = "quantity",
    REGEX = "regex",
    MINUS = "minus",
    COUNTRY_CODE = "country-code",
    SEARCH = "search",
    UP_AND_DOWN = "up-and-down",
    STAR_ON = "star-on",
    CIRCLE_ON = "circle-on",
    STAR_FILLED = "star-filled",
    STAR_HALF_FILLED = "star-half-filled",
    STAR_UNFILLED = "star-unfilled",
    CIRCLE_UNFILLED = "circle-unfilled",
    CIRCLE_FILLED = "circle-filled",
    CIRCLE_HALF = "circle-half",
    RIGHT = "right",
    LEFT = "left",
    DOMAIN = "domain",
    MULTILINE = "multiline",
    FILL_AGAIN = "fill-again",
    DOWNLOAD_PDF = "download-pdf",
    CROSSHAIR = "crosshair",
    CURRENT_LOCATION = "current-location",
    PREDEFINED = "predefined",
    COLUMNS = "columns",
    SIZE = "size",
    DAYS = "days",
    MOUNTHS = "months",
    ADD_OTHER = "add-other",
    AMPM = "ampm",
    GENDER = "gender",
    LINE = "line",
    ERASE = "erase",
    SCALEINPUT = "bottomInputs",
    PAYABLE = "payable",
    INCREMENT = "add-line",
    DECREMENT = "group",
    ONE_TIME_PAYMENT = "one_time_payment_type",
    SUBSCRIPTION = "subscription",
    DONATION = "donation",
    CASH = "cash",
    PROMOCODE = "promocode",
    INACTIVE_CHECKBOX = "inactive-checkbox",
    MESSAGE = "message",
    USER_SETTINGS = "user-settings",
    ROTATE = "rotate",
    MULTIPLE = "multiple",
}

interface IProps extends HTMLAttributes<HTMLElement> {
    type: IconTypes;
    size?: number;
    styles?: CSSProperties;
}

const Icon: FC<IProps> = ({ type, size, className, styles, ...props }) => (
    <i
        className={cx(`icon-${type}`, className)}
        style={{ fontSize: `${size}px`, lineHeight: `${size}px`, ...styles }}
        {...props}
    />
);

export default Icon;
